import { useMemo } from 'react';
import { preFixImgUrl } from '@/utils';

export const TEMP_COUPON_PAGE_SIZE = 12

const SameImageUrl = '4c8570e80dba2586e2dffe3e8468260f.png';

/** 临时优惠券门店列表：静态 22 条，轮播同站已有 CDN 图 */
const TEMP_COUPON_IMAGE_FILES = [
  'b2bd075579798c0c50561c9fda2111ba.png',
  '040d1eb8e10d727474ace03b76054a86.png',
  '319d5ee68ad53eefa34796c3abf44ba8.png',
  '661eba00941feb9285831055a804e9cc.png',
  '86f506a980013f31c4abec63de5aaea9.png',
  'c304f01bb09aa76cb8a263e7f83ff52f.png',
  '2b16fa4c6497997c0cfa728e6411cd54.png',
  'b0b1cb7b0eb75962306e2a4a0df168ee.png',
  '10a9d9e29a10eb1b01297f5bcadff4b4.png',
  '20708195ac5638aca33939d9934f020f.png',
  '6e04e9ee9cb3faf3dd9ac1be2f88f709.png',
  '1833bc4b133cd0e7fc4d78e7e1171493.png',
  'bdd395292bee8a84e6e717c53fb383b6.png',
  'd5b8132e3a100ec614f17a84279154e7.png',
  '9c5fd93efb59e07c87bf4e0555f4fa2b.png',
  'd02be355fef5bc58061ba712483c228c.png',
  '82f4b1b7b08f7c913438b8cb717b3219.png',
  '06a1476e7759ce4ad4f0bc875ad6d8b3.png',
  'b2aa1f4d1e06fc5d48c17b13aa7b8d3c.png',
  'b87351f15d0fd5e0a33bc6143791e061.png',
  '51dda36c4a865f61ab1e7478c10e212f.png',
  'de1b657fe47bf0a357d8d07c57fbf565.png'
] as const

const TEMP_COUPON_COUNT = 22

export type TempCouponStore = {
  id: string
  /** 列表/卡片用图 */
  imageFile: string
  /** 详情页专用大图；未配置时详情使用 `imageFile` */
  detailImageFile?: string
}

/**
 * 详情页优惠券图（与列表 `imageFile` 独立）。按 `store-${n}` 填写 CDN 文件名，未写的在详情中仍用列表图。
 * 例：'store-1': 'a1b2c3d4e5f6....png',
 */
const TEMP_COUPON_DETAIL_IMAGE_BY_ID: Partial<Record<string, string>> = {
  // 配置上线后在此补充，例如：'store-1': 'xxxxxxxx.png',
  'store-1': '4da29f084047e087c30b9560e084a7b6.png',
  'store-2': SameImageUrl,
  'store-3': SameImageUrl,
  'store-4': SameImageUrl,
  'store-5': SameImageUrl,
  'store-6': SameImageUrl,
  'store-7': '113db6a9607b21ab9b45131bff3f05d8.png',
  'store-8': 'fddd71ea6f20c46dc87f274c194d8f05.png',
  'store-9': 'd1123f584edf9399cc1368b0dec9035c.png',
  'store-10': '72ac4ca59f3eaf1a889e78fda986d48c.png',
  'store-11': SameImageUrl,
  'store-12': SameImageUrl,
  'store-13': 'de289589801e91b41bbb6cd06c79bafe.png',
  'store-14': '916d2da47f0823668ceaa03f2d6c59bd.png',
  'store-15': SameImageUrl,
  'store-16': SameImageUrl,
  'store-17': SameImageUrl,
  'store-18': SameImageUrl,
  'store-19': SameImageUrl,
  'store-20': SameImageUrl,
  'store-21': SameImageUrl,
  'store-22': SameImageUrl,
}

export const TEMP_COUPON_STORES: TempCouponStore[] = Array.from(
  { length: TEMP_COUPON_COUNT },
  (_, i) => {
    const id = `store-${i + 1}`
    return {
      id,
      imageFile: TEMP_COUPON_IMAGE_FILES[i % TEMP_COUPON_IMAGE_FILES.length]!,
      detailImageFile: TEMP_COUPON_DETAIL_IMAGE_BY_ID[id],
    }
  },
)

/** 详情展示用最终图片（有详情图用详情，否则用列表图） */
export function getTempCouponDetailImageFile(store: TempCouponStore): string {
  return store.detailImageFile ?? store.imageFile
}

export function getTempCouponById(id: string | null | undefined): TempCouponStore | undefined {
  if (!id) return undefined
  return TEMP_COUPON_STORES.find((s) => s.id === id)
}

export type CouponQuickLinkItem =
  | { key: string; iconImg: string; to: string }
  | { key: string; iconImg: string; href: string };

const COUPON_LIST_QUICK_LINKS = [
  {
    key: '00a5d8ee',
    iconFile: 'e62cca86d301cb431507da5775a49803.png',
    to: '/items',
  },
  {
    key: '487853f3',
    iconFile: '604ce17e39d715e03b02aba7b3874804.png',
    to: '/coupon-precautions',
  },
  {
    key: '2c7782ea',
    iconFile: '691e96c40a4369e0f941c4b9fdf709da.png',
    href: 'mailto:info.japanmall@jdxjp.net',
  },
] as const;

export default function useModel() {
  const quickLinks = useMemo<CouponQuickLinkItem[]>(
    () =>
      COUPON_LIST_QUICK_LINKS.map((row) => {
        const base = {
          key: row.key,
          iconImg: preFixImgUrl(row.iconFile),
        };
        if ('href' in row) {
          return { ...base, href: row.href };
        }
        return { ...base, to: row.to };
      }),
    [],
  );

  return { quickLinks };
}
